import { sortAnexos } from 'components/Modal/CadastroPautaModal/CadastroPautaModal';
import { AnexoEnum, AnexoPautaType } from 'helpers/enums/anexoPauta';
import { objectKeysFiltered } from 'helpers/utils/HTMLUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import {
  ButtonThemes,
  Col,
  Collapse,
  Modal,
  ModalSizes,
  Row,
  ThreeDotsLoader,
  TimesCircleIcon,
} from 'plataforma-fundacao-componentes';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { getAnexosPauta, getAnexosPautaAssociado } from 'services/anexoPauta';
import styles from './AssociadoAnexoPautaModal.scss';
import AssociadoAnexo from './components/AssociadoAnexo/AssociadoAnexo';
const { rootClassName } = styles;

interface Props extends ModalProps {
  idPauta: number;
  idEvento: number;
  tituloPauta: string;
  isAssessor?: boolean;
}

const keysToExclude: string[] = ['idPauta', 'idEvento', 'tituloPauta'];

const language = languageValues.modals.associadoAnexoPauta;
export default function AssociadoAnexoPautaModal(props: Props) {
  const [loading, setLoading] = useState<boolean>(true);
  const [anexos, setAnexos] = useState<AnexoPautaType[]>();

  useEffect(() => {
    setLoading(true);

    if (props.isAssessor) {
      getAnexosPauta(props.idEvento, props.idPauta)
        .then((resp) => {
          setAnexos(resp.data);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      getAnexosPautaAssociado(props.idEvento, props.idPauta)
        .then((resp) => {
          setAnexos(resp.data);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const documentos = useMemo(() => {
    if (!anexos || !anexos.length) return [];
    return anexos
      ?.filter((anexo) => anexo.tipoAnexo === AnexoEnum.DOCUMENTO)
      .sort(sortAnexos);
  }, [anexos]);

  const videos = useMemo(() => {
    if (!anexos || !anexos.length) return [];
    return anexos
      ?.filter((anexo) => anexo.tipoAnexo === AnexoEnum.VIDEO)
      .sort(sortAnexos);
  }, [anexos]);

  return (
    <Modal
      {...objectKeysFiltered<ModalProps>(props, keysToExclude)}
      title='Anexos'
      compenseColPaddingContent
      size={ModalSizes.Large}
      footer={[
        {
          theme: ButtonThemes.Secondary,
          leftIcon: <TimesCircleIcon />,
          children: languageValues.buttons.close,
          onClick: () => props.onClose!(props.modalKey),
        },
      ]}
    >
      <Row className={rootClassName}>
        <Col>{props.tituloPauta}</Col>
        <Collapse animateOpacity opened={loading}>
          <Col centralized>
            <ThreeDotsLoader />
          </Col>
        </Collapse>
        <Collapse animateOpacity opened={documentos.length > 0}>
          <Fragment>
            <hr />
            <Col>
              <b>{language.docs}</b>
            </Col>
            <Row>
              {documentos.map((doc) => {
                return (
                  <AssociadoAnexo
                    key={doc.oidAnexoPauta}
                    anexo={doc}
                    idEvento={props.idEvento}
                    idPauta={props.idPauta}
                    isAssessor={props.isAssessor}
                  />
                );
              })}
            </Row>
          </Fragment>
        </Collapse>
        <Collapse animateOpacity opened={videos.length > 0}>
          <Fragment>
            <hr />
            <Col>
              <b>{language.videos}</b>
            </Col>
            <Row>
              {videos.map((vid) => {
                return (
                  <AssociadoAnexo
                    key={vid.oidAnexoPauta}
                    anexo={vid}
                    idEvento={props.idEvento}
                    idPauta={props.idPauta}
                    isAssessor={props.isAssessor}
                  />
                );
              })}
            </Row>
          </Fragment>
        </Collapse>
        <Collapse
          animateOpacity
          opened={!loading && !documentos.length && !videos.length}
        >
          {language.semAnexos}
        </Collapse>
      </Row>
    </Modal>
  );
}
